(function() {
  "use strict";

  angular.module("PrintixNavigationBar", [])

    .constant("PrintixNavigationBarConstantsURLS", {
      NAV_BAR_ITEMS: "assets/jsonFiles/quickAccess/quickAccessItems.json"
    })

    .controller("NavigationBarController", ["$rootScope", "$scope", "Utils", "PrintixNavigationBarConstantsURLS",
      "URLS", "$http", "$injector", "$location", "toastr",  "$filter",
      function($rootScope, $scope, Utils, PrintixNavigationBarConstantsURLS, URLS, $http, $injector, $location, toastr,
         $filter) {

        $scope.maxButtonsAllowed = 6;
        $scope.urls = URLS;
        $scope.quickAccessButtonsList = [];
        $scope.requiredButtonItemProperties = ["icon", "url"];
        $scope.discoveryTasks = null;
        $scope.runningTask = null;
        $scope.ongoingGroupSync = false;

        $scope.addButtonItemToButtonItemsSuccessCallback = function(response) {
          $scope.quickAccessButtonsList = [];
          angular.forEach(response.data, function(buttonItem) {
            if (Utils.objectPropertiesCheck(buttonItem, $scope.requiredButtonItemProperties)) {
              $scope.quickAccessButtonsList.add(buttonItem);
            } else {
              console.log("invalid nav bar button item object");
              console.log(buttonItem);
            }
          });
        };

        $scope.getQuickAccessItems = function() {
          $http.get(PrintixNavigationBarConstantsURLS.NAV_BAR_ITEMS, {
            cache: true
          }).then($scope.addButtonItemToButtonItemsSuccessCallback);
        };

        if (!$scope.quickAccessButtonsList || $scope.quickAccessButtonsList.length < 1) {
          $scope.getQuickAccessItems();
        }

        $scope.$on("$locationChangeStart", function() {
          delete $rootScope.secondaryHeadline;
        });

        $scope.$watch(function(){
          return $rootScope.currentUser;
        }, function(){
          if ($rootScope.currentUser) {
            $scope.name = $rootScope.currentUser.info._embedded.user.name;
            $scope.role = $rootScope.currentUser.info._embedded.permissions.role;
          } 
        }, true);

        $scope.$watch(function() {
          return $location.path();
        }, function() {
          $scope.path = $location.path();
        }, true);

        $scope.gotoUser = function() {
          $location.path('/userProperties/' + $rootScope.currentUser.customProperties.id);
        }
      }
    ]);
})();